export function expandCompounds(tokens, library) {
    const libraryMap = new Map(library.map((c) => [c.normalizedName, c]));
    const result = [];
    for (const token of tokens) {
        const normalizedName = token.name.toLowerCase().trim();
        const compound = libraryMap.get(normalizedName);
        if (token.isCompound && compound) {
            const childIds = [];
            for (let i = 0; i < compound.subIngredients.length; i++) {
                const subName = compound.subIngredients[i];
                if (subName === undefined)
                    continue;
                const childId = `${token.id}-sub-${i}`;
                childIds.push(childId);
                result.push({
                    id: childId,
                    rawText: subName,
                    name: subName.toLowerCase().trim(),
                    quantity: null,
                    preparation: null,
                    startIndex: token.startIndex,
                    endIndex: token.endIndex,
                    isCompound: false,
                    subIngredientIds: [],
                    parentId: token.id,
                });
            }
            result.push({
                ...token,
                subIngredientIds: childIds,
            });
        }
        else if (token.isCompound) {
            const childIds = [];
            const parenMatch = token.rawText.match(/\(([^)]+)\)/);
            if (parenMatch) {
                const subs = parenMatch[1].split(',').map((s) => s.trim()).filter((s) => s.length > 0);
                for (let i = 0; i < subs.length; i++) {
                    const subName = subs[i];
                    const childId = `${token.id}-paren-${i}`;
                    childIds.push(childId);
                    result.push({
                        id: childId,
                        rawText: subName,
                        name: subName.toLowerCase().trim(),
                        quantity: null,
                        preparation: null,
                        startIndex: token.startIndex,
                        endIndex: token.endIndex,
                        isCompound: false,
                        subIngredientIds: [],
                        parentId: token.id,
                    });
                }
            }
            result.push({
                ...token,
                subIngredientIds: childIds,
            });
        }
        else {
            result.push(token);
        }
    }
    return result;
}
//# sourceMappingURL=expandCompounds.js.map